import { ValueOfKey } from '../../../../utils-types';

export const FLAGS = {
  SHOW_REACT_CUSTOMER_COMMUNICATION_FILTER_PARAMETERS:
    'show_react_customer_communication_filter_parameters',
  SHOW_ADD_SCAN_IQ_CUSTOMER_BUTTON: 'show_add_scan_iq_customer_button',
} as const;

export type UnleashFlagName = ValueOfKey<typeof FLAGS>;
